<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <create-thank></create-thank>
    </div>
  </div>
</template>

<script>
import CreateThank from "../../components/CreateThank.vue";

export default {
  components: {
    CreateThank
  },
  name: "Thank",
  data() {
    return {
      categorey: []
    };
  },
  methods: {
    logout(){
      // console.log("be",this.$store.state.user )
      if (this.$store.state.user !=null) {
        this.$store.dispatch("setToken", null);
        this.$store.dispatch("setUser", null);
        // this.$router.push("/login");
      }else{
        // this.$router.push("/login");
      }
      // console.log("af",this.$store.state.user )
    }
  },
  mounted() {},
  created() {
    this.logout();
  }
};
</script>
<style>
</style>
